module.exports = __webpack_public_path__ + "img/47.f52cb3b8.png";